module.exports = "/images/vi.svg?ff52ffaf839979230da3a0a69385ecf2";